module.exports = __webpack_public_path__ + "img/logoSky.49f03a58.png";